import { Stock } from '../../models/interfaces';

export type ExpirationStatus = 'expiring' | 'expired';

const DAY_MS = 24 * 60 * 60 * 1000;

// 'YYYY-MM-DD' como fecha local (new Date('YYYY-MM-DD') la toma en UTC y puede correrse un día)
const parseDate = (value: string) => {
    const [y, m, d] = value.slice(0, 10).split('-').map(Number);
    return new Date(y, m - 1, d);
};

const startOfDay = (date: Date) => new Date(date.getFullYear(), date.getMonth(), date.getDate());

// Días que faltan para el vencimiento (negativo si ya venció); null si el producto no maneja vencimiento
export const daysToExpiration = (stock: Pick<Stock, 'expirationDate'>, today = new Date()) => {
    if (!stock.expirationDate) return null;
    return Math.round((parseDate(stock.expirationDate).getTime() - startOfDay(today).getTime()) / DAY_MS);
};

// Vencido: la fecha de vencimiento ya pasó. Por vencer: faltan expirationNoticeDays días o menos (incluye hoy).
// Fuera del plazo de aviso o sin fecha: null (no se muestra nada).
export const getExpirationStatus = (stock: Pick<Stock, 'expirationDate' | 'expirationNoticeDays'>, today = new Date()): ExpirationStatus | null => {
    const days = daysToExpiration(stock, today);
    if (days === null) return null;
    if (days < 0) return 'expired';
    if (days <= (stock.expirationNoticeDays ?? 0)) return 'expiring';
    return null;
};

export const expirationConfig: Record<ExpirationStatus, { label: string; badgeClass: string }> = {
    expiring: { label: 'Por vencer', badgeClass: 'bg-warning text-dark' },
    expired: { label: 'Vencido', badgeClass: 'bg-danger' },
};

export const formatExpirationDate = (value?: string | null) => {
    if (!value) return '';
    const [y, m, d] = value.slice(0, 10).split('-');
    return `${d}/${m}/${y}`;
};

export const expirationTitle = (stock: Pick<Stock, 'expirationDate'>, today = new Date()) => {
    const days = daysToExpiration(stock, today);
    if (days === null) return '';
    const date = formatExpirationDate(stock.expirationDate);
    if (days < 0) return `Venció el ${date} (hace ${-days} día${days === -1 ? '' : 's'})`;
    if (days === 0) return `Vence hoy (${date})`;
    return `Vence el ${date} (en ${days} día${days === 1 ? '' : 's'})`;
};
